export default "/img/KE.d9cace2e02a216218e87b39a0feb0407.png";